
export type TodoListAccess = {
    add         : boolean
    edit        : boolean
}

export enum TodoType {
    TODO                = 'todo',
    TASK                = 'task'
}
